import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

type ErrorHandlerState = {
  ErrorCode: number | null;
};

const initialState: ErrorHandlerState = {
  ErrorCode: null,
};

const ErrorHandlerSlice = createSlice({
  name: "errorHandler",
  initialState,
  reducers: {
    setErrorCode: (state, action) => {
      state.ErrorCode = action.payload;
    },
  },
});

export const { setErrorCode } = ErrorHandlerSlice.actions;

export const selectErrorCode = (state: RootState) => {
  return state.errorHandler.ErrorCode;
};

export default ErrorHandlerSlice.reducer;
